import React from 'react';

export default function Services(): React.JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-6 py-16">
      <div className="rounded-2xl border border-mcc-lightest/60 bg-white p-8 md:p-12 shadow-sm">
        <h1 className="text-3xl font-bold text-mcc-darkest md:text-4xl">Our Services</h1>
        <p className="mt-4 text-slate-600 leading-relaxed text-lg">
          Page coming soon! Look forward to exploring our comprehensive caregiving solutions designed for clients, families, and care professionals.
        </p>
      </div>
    </div>
  );
}